
import { useQuery } from "@tanstack/react-query";
import { useProject } from "@/hooks/useProject";

export function useLaunchDataQueries(launchId: number, isOpen: boolean) {
  const { projectClient, currentProject } = useProject();
  
  const { data: launch, isLoading: isLoadingLaunch } = useQuery({
    queryKey: ["launch-edit", currentProject, launchId],
    queryFn: async () => {
      const { data, error } = await projectClient
        .from("form_launches")
        .select(`
          *,
          clientes (id, nombre),
          report_templates (id, name),
          jotform_form_mappings:form_mapping_id (id, jotform_form_id, form_title),
          report_templates_v2:template_v2_id (id, name)
        `)
        .eq("id", launchId)
        .single();

      if (error) throw error;
      return data;
    },
    enabled: isOpen,
  });

  const { data: formMappings } = useQuery({
    queryKey: ["form-mappings", currentProject],
    queryFn: async () => {
      const { data, error } = await projectClient
        .from("jotform_form_mappings")
        .select("id, jotform_form_id, form_title")
        .order("form_title");

      if (error) throw error;
      return data;
    },
    enabled: isOpen,
  });

  const { data: clients } = useQuery({
    queryKey: ["clients", currentProject],
    queryFn: async () => {
      const { data, error } = await projectClient
        .from("clientes")
        .select("id, nombre")
        .order("nombre");

      if (error) throw error;
      return data;
    },
    enabled: isOpen,
  });

  const { data: templates } = useQuery({
    queryKey: ["templates-v2", currentProject],
    queryFn: async () => {
      const { data, error } = await projectClient
        .from("report_templates_v2")
        .select("id, name")
        .order("name");

      if (error) throw error;
      return data;
    },
    enabled: isOpen,
  });

  return {
    launch,
    isLoadingLaunch,
    formMappings,
    clients,
    templates,
  };
}
